/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_Link_DofollowInputs */

const en_directory_external_directories_link_dofollow = /** @type {(inputs: Directory_External_Directories_Link_DofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dofollow`)
};

const zh_directory_external_directories_link_dofollow = /** @type {(inputs: Directory_External_Directories_Link_DofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dofollow`)
};

/**
* | output |
* | --- |
* | "Dofollow" |
*
* @param {Directory_External_Directories_Link_DofollowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_link_dofollow = /** @type {((inputs?: Directory_External_Directories_Link_DofollowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Link_DofollowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_link_dofollow(inputs)
	return zh_directory_external_directories_link_dofollow(inputs)
});
export { directory_external_directories_link_dofollow as "directory.external_directories.link_dofollow" }